<nav class="sh-tab-navigation--small">
    <a
        *ngFor="let scrollspyNavItem of scrollspyNavItems$ | async"
        [href]="'#' + scrollspyNavItem.target"
        class="sh-tab-navigation__item"
        [ngClass]="{'-sh-is-active': scrollspyNavItem.firstActive}"
        [attr.aria-current]="scrollspyNavItem.firstActive ? 'location': null"
        (click)="scrollToTarget($event, scrollspyNavItem.target)"
    >
        {{ scrollspyNavItem.label }}
    </a>
</nav>
